import { render, staticRenderFns } from "./folders-modal-add-folder.vue?vue&type=template&id=82b04c92&scoped=true"
import script from "./folders-modal-add-folder.vue?vue&type=script&lang=js"
export * from "./folders-modal-add-folder.vue?vue&type=script&lang=js"
import style0 from "./folders-modal-add-folder.vue?vue&type=style&index=0&id=82b04c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b04c92",
  null
  
)

export default component.exports